
import { API_STORE } from "@/config";
import { getAPIAuthorizedHeader } from "@/services/common";
import Axios from "axios";
import { Component, Vue, Prop } from "vue-property-decorator";
import saveAs from "save-as";
import print from "print-js";

@Component({})
export default class AepsPopupComponent extends Vue {
  @Prop() public data;

  public async action(type) {
      this.$showLoader(true);
      let response = await Axios.post(
        API_STORE.SERVICE + `downloadAepsInvoice/${this.$userId}`,
        this.data,
        {
          headers: getAPIAuthorizedHeader(),
          responseType: "blob",
        }
      );
      this.$showLoader(false);
      if(response){
      if (type == "print") {
        let printUrl = URL.createObjectURL(response.data);
        print(printUrl);
      } else {
        saveAs(
          response.data,
          "InstantPayment_" + this.data.transactionId + ".pdf"
        );
      }
      this.$emit("updateDmtSuccessful", true);
      }
  }

  resetForm() {
    this.$emit("cancel", true);
  }

  withdrawl() {
    this.$emit("cancel", true);
    this.$emit("aepsWithdrawBalance",true);
  }
}
